import { getElement, getElements, ifSelectorExist, getCookie } from "./utils-child";

export const lightbox = () => {
  let lightbox = new FsLightbox();
  let images = document.querySelectorAll(".wp-block-gallery img");

  if (ifSelectorExist(images)) {
    let sources = Array.from(images).map((image) => image.src);

    lightbox.props.sources = sources;

    images.forEach((image, index) => {
      image.addEventListener("click", () => {
        lightbox.open(index);
      });
    });
  }
};
